<template>
  <div id="person_vips_outer" v-if="user != null">

    <div id="certificate_full_outer" v-if="showFullImage">
      <div>
        <a href="javascript:void(null);" @click="closeFullImage">
          <img class="close-button" src="../../assets/shl_video_close_btn.png">
        </a>
        <div class="certificate-outer">
          <img :src="imageUrl">
        </div>
      </div>
    </div>

    <div v-if="!outDate" class="vips_top_label">恭喜您，已成为认证会员！</div>
    <div v-else class="vips_top_label" >会员已过期，<a>前往年审>>></a></div>
    <div id="person_vips_content_outer">
      <div>
        <div class="vips_content_label">会员证书</div>
        <div id="vips_content_canvas_outer">
          <img id="vips_certificate_img" v-if="imageUrl != null" :src="imageUrl" @click="certificateImageClicked" style="width: auto;height: auto;max-width: 100%;">
          <div v-show="outDate" style="position: absolute;width: 100%;height: 100%;background-color: rgba(0,0,0,0.3);left: 0;top:0;"></div>
        </div>

        <div class="vips-content-issue-date">
          <div>证书颁发日期:</div>
          <div>{{issueDate}}</div>
        </div>

        <div class="vips-content-desc">
          此证书的有效期为1年，将在{{validDateText}}到期，需要在{{payBeginDateText}}至{{validDateText}}完成年审。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PersonalVipsDetail",
  props: {

  },
  data() {
    return {
      title: '个人会员',
      showCanvas: true,
      imageUrl: null,
      showFullImage: false,
      isUpdateUser: false,
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    issueDate() {
      if (this.user == null) {
        return '';
      }
      let validDate = this.$moment(this.user.memberValidDate);
      if (validDate.isValid()) {
        let issueDate = validDate.add('-1', 'years');
        issueDate.add('1', 'days');
        return issueDate.format('YYYY.MM.DD');
      }
      return  '';
    },

    outDate() {
      if (this.user == null) {
        return false;
      }
      return  !this.$moment(this.user.memberValidDate).isValid();
    },

    validDateText() {
      if (this.user != null && this.$moment(this.user.memberValidDate).isValid()) {
        return this.$moment(this.user.memberValidDate).format('YYYY.MM.DD')
      }
      return '';
    },

    payBeginDateText() {
      if (this.user != null &&  !this.$moment(this.user.memberValidDate).isValid()) {
        return '';
      }
      let validDate = new Date(this.user.memberValidDate);
      let beginDate = new Date(validDate.getTime() - (1000 * 60 * 60 * 24 * 15));
      return  this.$moment(beginDate).format('YYYY.MM.DD');
    }

  },
  mounted() {
    this.loadData();
  },
  methods: {
    dealWithUserData() {
      if (this.user != null) {
        let _this = this;
        this.drawCertificateImage(this.user, function (image) {
          _this.imageUrl = image;
        })
      }
    },

    loadData() {
      if (this.isUpdateUser) {
        return;
      }
      this.isUpdateUser = true;
      let _this = this;
      this.$store.state.http.ajax.ucProfile(function (data) {
        _this.isUpdateUser = false;
        let code = data.code;
        if (code == 0) {
          let user = data.data;
          _this.$store.commit('setUser', user);
          _this.dealWithUserData();
        } else {
          _this.$toast('数据加载失败！');
        }
      }, function (data) {
        _this.isUpdateUser = false;
        _this.$toast('数据加载失败，请重试！');
      })
    },


    certificateImageClicked() {
      this.showFullImage = true;
    },
    closeFullImage() {
      this.showFullImage = false;
    }
  }
}
</script>

<style scoped>

  #person_vips_outer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 50px;
    padding-left: 5px;
    padding-right: 5px;
  }

  .vips_top_label {
    font-size: 2rem;
    color: #cbb042;
    font-weight: bold;
    margin-top: 10px;
  }

  .vips_top_label a {
    text-decoration: none;
    color: #e71432;
    font-weight: inherit;
  }

  .vips_top_label a:hover {
    color: #cbb042;
  }
  #person_vips_content_outer {
    min-width: 290px;
    border: solid 1px #cbb042;
    margin-top: 4vh;
    width: 100%;
    padding-bottom: 8vh;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
  }

  #person_vips_content_outer > div {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    width: 90%;
    min-width: 270px;
    max-width: 470px;
    margin-top: 30px;
  }

  .vips_content_label {
    color: #cbb042;
    font-size: 2rem;
    font-weight: bold;
    letter-spacing: 1px;
  }

  .vips-content-issue-date {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 25px;
    padding-left: 2px;
    padding-right: 2px;
  }

  .vips-content-issue-date > div:first-child {
    color: #cbb042;
    font-size: 1.5rem;
    width: 40%;
  }

  .vips-content-issue-date > div:last-child {
    color: #999;
    border: solid 1px #cbb042;
    border-radius: 4px;
    padding: 5px 20px;
    width: 55%;
    text-align: center;
  }

  .vips-content-desc {
    font-size: 1.5rem;
    color: #333;
    max-width: 100%;
    margin-top: 30px;
    letter-spacing: 1px;
  }

  #vips_content_canvas_outer {
    text-align: center;
    /*background-color: yellow;*/
    margin-top: 30px;
    position:relative;
  }


  @media screen and (min-width: 414px) {
    .vips-content-issue-date > div:first-child {
      width: 35%;
    }

    .vips-content-issue-date > div:last-child {
      width: 60%;
    }
  }


  @media screen and (min-width: 768px) {

    .vips-content-issue-date > div:first-child {
      width: 30%;
    }

    .vips-content-issue-date > div:last-child {
      width: 65%;
    }
  }

  #certificate_full_outer {
    background-color: rgba(0,0,0,0.3);
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    z-index: 999;
  }

  #certificate_full_outer > div {
    background-color: white;
    position: relative;
    overflow: scroll;
  }

  #certificate_full_outer .close-button {
    width: 50px;
    height: auto;
    position: absolute;
    right: 15px;
    top: 15px;
    width: 30px;
    height: auto;
    z-index: 100;
  }

  #certificate_full_outer .certificate-outer {
    /*margin-top: 55px;*/
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

  }

  #certificate_full_outer .certificate-outer > img {
    /*width: 100%;*/
    height: auto;
    max-height: 90vh;
    max-width: 100vw;
    width: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/personal/PersonalVipsDetail.vue